function sizeGuideWindow() {
  
  var sizeGuideWindow = $('.size-guide-popup'),
  sizeGuideWindowClose = $('.modal-close-icon'),
  sizeGuideLink = $('.size__guide__link');

  sizeGuideLink.on('click', function(){
    sizeGuideWindow.addClass('d-block');
    sizeGuideWindow.removeClass('d-none');
    $('.modal-overlay').addClass('active');
  });
  
  sizeGuideWindowClose.on('click', function(){
      sizeGuideWindow.addClass('d-none');
      sizeGuideWindow.removeClass('d-block');
      $('.modal-overlay').removeClass('active');
  });

  $('.modal-overlay').on('click', function(){
      sizeGuideWindow.addClass('d-none');
      sizeGuideWindow.removeClass('d-block');
      $(this).removeClass('active');
  });
}

if ($('body.template-product').length) {
  sizeGuideWindow();
}